export const getTaskList = state => {
    return state.list
}

export const getTaskDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tasks/getters.js